import instance from "../Config/Config";

export const material_enquiry_url = "material_enquriy"
export const material_enquiry_list_url = "my_material_list"
export const service_enquiry_list_url = "my_services_list"
export const newsletter_url = "newsletter/subscribe"
export const contact_enquiry_url = "contact-enquiry"


export const material_enquiry = async(value)=>{
    const response = await instance.post(`${material_enquiry_url}`, value)
    return response.data
}


export const material_enquiry_list = async()=>{
    const response = await instance.get(`${material_enquiry_list_url}`)
    return response.data
}
export const service_enquiry_list = async()=>{
    const response = await instance.get(`${service_enquiry_list_url}`)
    return response.data
}


export const subscribe_newsletter = async(value)=>{
    const response = await instance.post(`${newsletter_url}`, value)
    return response.data
}


export const contact_enquiry = async(value)=>{
    const response = await instance.post(`${contact_enquiry_url}`, value)
    return response.data
}

export const vendor_material_enquiry_list_url = "my_material_enquiry_list"
export const vendor_services_enquiry_list_url = "my_services_enquiry_list"

export const vendor_material_enquiry_list = async () => {
    const response = await instance.get(`${vendor_material_enquiry_list_url}`)
    return response.data
}

export const vendor_services_enquiry_list = async () => {
    const response = await instance.get(`${vendor_services_enquiry_list_url}`)
    return response.data
}
